export enum DungeonMusic {
  AEGIS_CAVE = "Aegis Cave",
  AMP_PLAINS = "Amp Plains",
  A_NEW_WORLD = "A New World",
  APPLE_WOODS = "Apple Woods",
  AT_THE_SNOWY_MOUNTAIN = "At the Snowy Mountain",
  AT_THE_END_OF_THE_DAY = "At the End of the Day", // UNUSED
  BARREN_VALLEY = "Barren Valley",
  BATTLE_WITH_RAYQUAZA = "Battle with Rayquaza",
  BEACH_CAVE = "Beach Cave",
  BLIZZARD_ISLAND = "Blizzard Island Rescue Team Medley",
  BOSS_BATTLE = "Boss Battle!",
  BOULDER_QUARRY = "Boulder Quarry",
  BRINE_CAVE = "Brine Cave",
  BURIED_RELIC = "Buried Relic",
  CARNIVAL_LUDICOLO = "Carnival Ludicolo",
  CAVE_AND_SIDE_PATH = "Cave and Side Path",
  CHASM_CAVE = "Chasm Cave",
  CONCEALED_RUINS = "Concealed Ruins",
  CRAGGY_COAST = "Craggy Coast",
  CRYSTAL_CAVE = "Crystal Cave",
  CRYSTAL_CROSSING = "Crystal Crossing",
  DARK_CRATER = "Dark Crater",
  DARK_HILL = "Dark Hill",
  DARK_ICE_MOUNTAIN = "Dark Ice Mountain",
  DARK_WASTELAND = "Dark Wasteland",
  DEEP_DARK_CRATER = "Deep Dark Crater",
  DEEP_DUSK_FOREST = "Deep Dusk Forest",
  DEEP_STAR_CAVE = "Deep Star Cave",
  DEFY_THE_LEGENDS = "Defy the Legends",
  DIALGA_FIGHT_TO_THE_FINISH = "Dialga's Fight to the Finish!",
  DRENCHED_BLUFF = "Drenched Bluff",
  DUSK_FOREST = "Dusk Forest",
  ESCAPE_THROUGH_THE_SNOW = "Escape Through the Snow",
  FAR_AMP_PLAINS = "Far Amp Plains",
  FOGGY_FOREST = "Foggy Forest",
  FORTUNE_RAVINE = "Fortune Ravine",
  FORTUNE_RAVINE_DEPTHS = "Fortune Ravine Depths", // UNUSED
  FRIEND_AREA_CAVES = "Friend Area - Caves",
  FRIEND_AREA_FOREST = "Friend Area - Forest",
  FRIEND_AREA_GRASSLANDS = "Friend Area - Grasslands",
  FRIEND_AREA_LAB = "Friend Area - Lab",
  FRIEND_AREA_OCEANIC = "Friend Area - Oceanic",
  FRIEND_AREA_POND = "Friend Area - Pond",
  FRIEND_AREA_STEPPE = "Friend Area - Steppe",
  FRIEND_AREA_SWAMP = "Friend Area - Swamp",
  FRIEND_AREA_WILDS = "Friend Area - Wilds",
  FROSTY_FOREST = "Frosty Forest",
  FROSTY_GROTTO = "Frosty Grotto",
  GARDEVOIR_INSIDE_OF_A_DREAM = "Gardevoir Inside of a Dream",
  GOODNIGHT = "Goodnight",
  GREAT_CANYON = "Great Canyon",
  GROWING_ANXIETY = "Growing Anxiety",
  HIDDEN_HIGHLAND = "Hidden Highland",
  HIDDEN_LAND = "Hidden Land",
  I_SAW_SOMETHING_AGAIN = "I Saw Something Again",
  ICICLE_FOREST = "Icicle Forest",
  ILLUSION_STONE_CHAMBER = "Illusion Stone Chamber",
  IN_THE_FUTURE = "In the Future",
  IN_THE_HANDS_OF_FATE = "In the Hands of Fate", // UNUSED
  IN_THE_NIGHTMARE = "In the Nightmare",
  JOB_CLEAR = "Job Clear!",
  KECLEONS_SHOP = "Kecleon's Shop",
  LAPIS_CAVE = "Lapis Cave",
  LIMESTONE_CAVERN = "Limestone Cavern",
  LIVING_SPIRIT = "Living Spirit",
  LOWER_BRINE_CAVE = "Lower Brine Cave",
  MAGMA_CAVERN = "Magma Cavern",
  MAGMA_CAVERN_PIT = "Magma Cavern Pit",
  MAKUHITA_DOJO = "Makuhita Dojo",
  MAROWAK_DOJO = "Marowak Dojo",
  MIRACLE_SEA = "Miracle Sea",
  MONSTER_HOUSE = "Monster House!",
  MT_BLAZE = "Mt. Blaze",
  MT_BLAZE_PEAK = "Mt. Blaze Peak",
  MT_BRISTLE = "Mt. Bristle",
  MT_FREEZE = "Mt. Freeze",
  MT_HORN = "Mt. Horn",
  MT_STEEL = "Mt. Steel",
  MT_THUNDER = "Mt. Thunder",
  MT_THUNDER_PEAK = "Mt. Thunder Peak",
  MT_TRAVAIL = "Mt. Travail",
  MURKY_FOREST = "Murky Forest",
  MYSTIFYING_FOREST = "Mystifying Forest",
  NORTHERN_DESERT = "Northern Desert",
  OH_NO = "Oh No!",
  ON_THE_BEACH_AT_DUSK = "On the Beach at Dusk",
  OUTLAW = "Outlaw!",
  PERSONALITY_TEST = "Personality Test",
  PLANETS_PARALYSIS = "Planet's Paralysis",
  POKEMON_SQUARE = "Pokemon Square",
  PROTECTED_WORLD_PEACE = "Protected World Peace",
  QUICKSAND_CAVE = "Quicksand Cave",
  QUICKSAND_PIT = "Quicksand Pit",
  RANDOM_DUNGEON_1 = "Random Dungeon 1",
  RANDOM_DUNGEON_2 = "Random Dungeon 2",
  RANDOM_DUNGEON_3 = "Random Dungeon 3",
  RESCUE_TEAM_BASE = "Rescue Team Base",
  RISING_FEAR = "Rising Fear",
  RUN_AWAY = "Run Away",
  SEALED_RUIN_PIT = "Sealed Ruin Pit",
  SHAYMIN_VILLAGE = "Shaymin Village",
  SILENT_CHASM = "Silent Chasm",
  SINISTER_WOODS = "Sinister Woods",
  SKY_PEAK_CAVE = "Sky Peak Cave", // UNUSED
  SKY_PEAK_COAST = "Sky Peak Coast",
  SKY_PEAK_FINAL_PASS = "Sky Peak Final Pass",
  SKY_PEAK_FOREST = "Sky Peak Forest",
  SKY_PEAK_PRAIRIE = "Sky Peak Prairie",
  SKY_PEAK_SNOWFIELD = "Sky Peak Snowfield",
  SKY_TOWER = "Sky Tower",
  SKY_TOWER_SUMMIT = "Sky Tower Summit",
  SOUTHERN_JUNGLE = "Southern Jungle",
  SPACIAL_CLIFFS = "Spacial Cliffs",
  SPINDA_CAFE = "Spinda's Cafe", // UNUSED
  SPRING_CAVE = "Spring Cave",
  SPRING_CAVE_DEPTHS = "Spring Cave Depths",
  STAFF_ROLL = "Staff Roll",
  STAR_CAVE = "Star Cave",
  STEAM_CAVE = "Steam Cave",
  STOP_THIEF = "Stop! Thief!",
  STORMY_SEA = "Stormy Sea",
  SURROUNDED_SEA = "Surrounded Sea",
  TEAM_CHARM_THEME = "Team Charm's Theme",
  TEAM_SKULL = "Team Skull",
  TEMPORAL_PINNACLE = "Temporal Pinnacle",
  TEMPORAL_SPIRE = "Temporal Spire",
  TEMPORAL_TOWER = "Temporal Tower",
  THE_LEGEND_OF_NINETALES = "The Legend of Ninetales",
  THE_POWER_OF_DARKNESS = "The Power of Darkness",
  THERES_TROUBLE = "There's Trouble!",
  THROUGH_THE_SEA_OF_TIME = "Through the Sea of Time",
  THUNDERWAVE_CAVE = "Thunderwave Cave",
  TIME_GEAR = "Time Gear",
  TIME_GEAR_REMIX = "Time Gear Remix",
  TINY_WOODS = "Tiny Woods",
  TOP_MENU_THEME = "Top Menu Theme",
  TREASURE_TOWN = "Treasure Town",
  TREASURE_TOWN_STAGE_0 = "Treasure Town Stage 0",
  TREASURE_TOWN_STAGE_10 = "Treasure Town Stage 10",
  TREASURE_TOWN_STAGE_20 = "Treasure Town Stage 20",
  TREASURE_TOWN_STAGE_0_ALT = "Treasure Town Stage 0 alt",
  TREASURE_TOWN_STAGE_10_ALT = "Treasure Town Stage 10 alt",
  TREASURE_TOWN_STAGE_20_ALT = "Treasure Town Stage 20 alt",
  TREESHROUD_FOREST = "Treeshroud Forest",
  TROUBLE_IN_TOWN = "Trouble in Town",
  UPPER_STEAM_CAVE = "Upper Steam Cave",
  VAST_ICE_MOUNTAIN = "Vast Ice Mountain",
  VAST_ICE_MOUNTAIN_PEAK = "Vast Ice Mountain Peak",
  VERSUS_BOSS = "Versus Boss",
  VERSUS_LEGENDARY = "Versus Legendary",
  WATERFALL_CAVE = "Waterfall Cave",
  WELCOME_TO_THE_WORLD_OF_POKEMON = "Welcome To the World of Pokemon!",
  WIGGLYTUFFS_GUILD = "Wigglytuff's Guild",
  WIGGLYTUFFS_GUILD_REMIX = "Wigglytuff's Guild Remix",
  WORLD_CALAMITY = "World Calamity"
}

export enum DungeonPMDO {
  AmpPlains = "AmpPlains",
  AppleWoods = "AppleWoods",
  BarrenValley = "BarrenValley",
  BeachCave = "BeachCave",
  BrineCave = "BrineCave",
  BuriedRelic1 = "BuriedRelic1",
  BuriedRelic2 = "BuriedRelic2",
  BuriedRelic3 = "BuriedRelic3",
  ConcealedRuins = "ConcealedRuins",
  CraggyCoast = "CraggyCoast",
  CrystalCave1 = "CrystalCave1",
  CrystalCave2 = "CrystalCave2",
  CrystalCrossing = "CrystalCrossing",
  DarkCrater = "DarkCrater",
  DarkHill1 = "DarkHill1",
  DarkHill2 = "DarkHill2",
  DarkIceMountain = "DarkIceMountain",
  DarkIceMountainPeak = "DarkIceMountainPeak",
  DarknightRelic = "DarknightRelic",
  DarkWasteland = "DarkWasteland",
  DeepBoulderQuarry = "DeepBoulderQuarry",
  DeepDarkCrater = "DeepDarkCrater",
  DeepDuskForest1 = "DeepDuskForest1",
  DeepDuskForest2 = "DeepDuskForest2",
  DeepLimestoneCavern = "DeepLimestoneCavern",
  DeepSealedRuin = "DeepSealedRuin",
  DesertRegion = "DesertRegion",
  DrenchedBluff = "DrenchedBluff",
  DuskForest1 = "DuskForest1",
  DuskForest2 = "DuskForest2",
  ElectricMaze = "ElectricMaze",
  FarAmpPlains = "FarAmpPlains",
  FinalMaze2 = "FinalMaze2",
  FoggyForest = "FoggyForest",
  ForestPath = "ForestPath",
  FrostyForest = "FrostyForest",
  FutureTemporalSpire = "FutureTemporalSpire",
  FutureTemporalTower = "FutureTemporalTower",
  GoldenChamber = "GoldenChamber",
  GrassMaze = "GrassMaze",
  GreatCanyon = "GreatCanyon",
  HiddenHighland = "HiddenHighland",
  HiddenLand = "HiddenLand",
  HowlingForest1 = "HowlingForest1",
  HowlingForest2 = "HowlingForest2",
  IceAegisCave = "IceAegisCave",
  IceMaze = "IceMaze",
  IcicleForest = "IcicleForest",
  JoyousTower = "JoyousTower",
  LapisCave = "LapisCave",
  LightningField = "LightningField",
  LimestoneCavern = "LimestoneCavern",
  LowerBrineCave = "LowerBrineCave",
  LushPrairie = "LushPrairie",
  MagmaCavern2 = "MagmaCavern2",
  MagmaCavern3 = "MagmaCavern3",
  MeteorCave = "MeteorCave",
  MiracleSea = "MiracleSea",
  MoonlitCourtyard = "MoonlitCourtyard",
  MtBlaze = "MtBlaze",
  MtBristle = "MtBristle",
  MtFaraway2 = "MtFaraway2",
  MtFaraway4 = "MtFaraway4",
  MtFreeze = "MtFreeze",
  MtHorn = "MtHorn",
  MtSteel1 = "MtSteel1",
  MtSteel2 = "MtSteel2",
  MtThunder = "MtThunder",
  MtThunderPeak = "MtThunderPeak",
  MtTravail = "MtTravail",
  MurkyCave = "MurkyCave",
  MurkyForest = "MurkyForest",
  MysteryJungle1 = "MysteryJungle1",
  MysteryJungle2 = "MysteryJungle2",
  MystifyingForest = "MystifyingForest",
  NorthernDesert1 = "NorthernDesert1",
  NorthernDesert2 = "NorthernDesert2",
  NorthernRange1 = "NorthernRange1",
  NorthernRange2 = "NorthernRange2",
  NorthwindField = "NorthwindField",
  PitfallValley1 = "PitfallValley1",
  PoisonMaze = "PoisonMaze",
  PurityForest2 = "PurityForest2",
  PurityForest4 = "PurityForest4",
  PurityForest6 = "PurityForest6",
  PurityForest7 = "PurityForest7",
  QuicksandCave = "QuicksandCave",
  QuicksandPit = "QuicksandPit",
  QuicksandUnused = "QuicksandUnused",
  RescueTeamMaze = "RescueTeamMaze",
  RockAegisCave = "RockAegisCave",
  RockMaze = "RockMaze",
  RockPathRB = "RockPathRB",
  RockPathTDS = "RockPathTDS",
  SealedRuin = "SealedRuin",
  SidePath = "SidePath",
  SilentChasm = "SilentChasm",
  SkyPeak4thPass = "SkyPeak4thPass",
  SkyPeak7thPass = "SkyPeak7thPass",
  SkyPeakSummitPass = "SkyPeakSummitPass",
  SkyTower = "SkyTower",
  SnowPath = "SnowPath",
  SolarCave1 = "SolarCave1",
  SouthernCavern1 = "SouthernCavern1",
  SouthernCavern2 = "SouthernCavern2",
  SouthernJungle = "SouthernJungle",
  SpacialCliffs = "SpacialCliffs",
  SpacialRift1 = "SpacialRift1",
  SpacialRift2 = "SpacialRift2",
  SteamCave = "SteamCave",
  SteelAegisCave = "SteelAegisCave",
  StormySea1 = "StormySea1",
  StormySea2 = "StormySea2",
  SurroundedSea = "SurroundedSea",
  TemporalSpire = "TemporalSpire",
  TemporalTower = "TemporalTower",
  TemporalUnused = "TemporalUnused",
  TestDungeon = "TestDungeon",
  TheNightmare = "TheNightmare",
  ThunderwaveCave = "ThunderwaveCave",
  TinyMeadow = "TinyMeadow",
  TinyWoods = "TinyWoods",
  TreeshroudForest1 = "TreeshroudForest1",
  TreeshroudForest2 = "TreeshroudForest2",
  UnusedBrineCave = "UnusedBrineCave",
  UnusedSteamCave = "UnusedSteamCave",
  UnusedWaterfallPond = "UnusedWaterfallPond",
  UproarForest = "UproarForest",
  VastIceMountain = "VastIceMountain",
  VastIceMountainPeak = "VastIceMountainPeak",
  WaterfallCave = "WaterfallCave",
  WaterfallPond = "WaterfallPond",
  WaterMaze = "WaterMaze",
  WesternCave1 = "WesternCave1",
  WesternCave2 = "WesternCave2",
  WishCave1 = "WishCave1",
  WishCave2 = "WishCave2",
  WorldAbyss2 = "WorldAbyss2",
  WyvernHill = "WyvernHill",
  ZeroIsleEast3 = "ZeroIsleEast3",
  ZeroIsleEast4 = "ZeroIsleEast4",
  ZeroIsleSouth1 = "ZeroIsleSouth1",
  ZeroIsleSouth2 = "ZeroIsleSouth2"
}

export const DungeonMusicCredits: { [key in DungeonMusic]?: string } = {
  [DungeonMusic.TROUBLE_IN_TOWN]: "John Rei",
  [DungeonMusic.TREASURE_TOWN_STAGE_0_ALT]: "John Rei",
  [DungeonMusic.TREASURE_TOWN_STAGE_10_ALT]: "John Rei",
  [DungeonMusic.TREASURE_TOWN_STAGE_20_ALT]: "John Rei",
  [DungeonMusic.TREASURE_TOWN_STAGE_0]: "L'Improyable",
  [DungeonMusic.TREASURE_TOWN_STAGE_10]: "L'Improyable",
  [DungeonMusic.TREASURE_TOWN_STAGE_20]: "L'Improyable"
}
